import Vue from 'vue';

/*环境*/
import Env from './config/env';
const env = Vue.prototype.$env = Env[{
	'provider.5aday.com.cn': 'test',
	'provider.shanshi.net.cn': 'release',
	'information.shanshi.net.cn': 'release'
}[location.hostname] || 'dev'];


if (location.hostname == 'information.shanshi.net.cn') {
	if (![
		'/static/views/share.html',
		'/static/views/activity.html'
	].includes(location.pathname) || ![
		'/activity',
		'/help'
	].includes(location.hash)) {
		location.href = '/#/activity';
	}
}


/*基础CSS*/
import './css/base.less';

/*Vue扩展库*/
import './css/vue-ext.less';
import './css/theme/default.less';
import VueExt from './vue-ext';
import actions from './config/actions';
Vue.use(VueExt, {
	components: {
		Image: {
			get origin() {
				return Vue.prototype.$store.config.image;
			},
			default: env.image.default
		}
	},
	action: {
		actions,
		origin: env.origin,
		plugins: { env },
		request(req, next) {
			let xhr = new XMLHttpRequest(), isGet = req.method == 'GET',
				query = isGet ? Vue.ext.url.toQuery(Object.assign({}, req.query, req.body)) : req.query;
			xhr.responseType = 'json';
			xhr.withCredentials = true;
			xhr.onload = () => next(xhr.response);
			xhr.open(req.method, req.url + `${query}`.replace(/^(.+)$/gm, '?$1'));
			xhr.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
			xhr.send(isGet || JSON.stringify(req.body));
		},
		response(res, next) {
			if (res.success) {
				Vue.ext.session.loginTime = Date.now();
				next(res.result);
			} else {
				Vue.ext.message.error(res.msg);
			}
		}
	}
});

Vue.prototype.$config = {
	doc: env.doc,
	share: env.share,
	video: env.video
};

/*路由*/
import router from './config/router';
router.beforeEach((to, from, next) => {
	if (vm) vm.$el.scrollTop = 0;
	if (location.hostname == 'information.shanshi.net.cn' && !['/activity', '/help'].includes(to.path)) {
		next({ path: '/activity', replace: true });
	} else if (['/activity', '/login', '/help'].includes(to.path) || Date.now() - Vue.ext.session.loginTime < 1800000) {
		next();
	} else {
		next({ path: '/login', replace: true });
	}
});

/*根视图*/
import App from './app';

/*挂载应用*/
let vm = new Vue({
	router,
	render: r => r(App)
}).$mount('#app');


// WEBPACK FOOTER //
// ./src/main.js